<!-- src/components/AuditScoreSummary.vue -->
<template>
  <div class="card core-card">
    <div class="card-content blue-grey darken-4 white-text audit-header">
      <div class="row audit-header-row">
        <div class="col s12 m7">
          <span class="card-title">{{ title }}</span>

          <div class="white-text header-subtitle">
            {{ subtitle }}
          </div>

          <div v-if="meta" class="white-text header-meta">
            {{ meta }}
          </div>
        </div>

        <div class="col s12 m5 score-col">
          <div class="row score-pill-row">
            <div class="col s4">
              <div class="pill">
                <div class="label">Venue</div>
                <div class="value">{{ venueScore }}%</div>
              </div>
            </div>

            <div class="col s4">
              <div class="pill">
                <div class="label">Admin</div>
                <div class="value">{{ adminScore }}%</div>
              </div>
            </div>

            <div class="col s4">
              <div class="pill">
                <div class="label">Done</div>
                <div class="value">{{ answeredCount }}/{{ totalCount }}</div>
              </div>
            </div>
          </div>

          <div v-if="totalCount > 0" class="progress-wrap">
            <div class="core-progress">
              <div
                class="core-progress-fill"
                :style="{ width: progressPercent + '%' }"
              ></div>
            </div>

            <div class="white-text progress-text">{{ progressPercent }}% complete</div>
          </div>
        </div>
      </div>

      <div v-if="message" class="message-row">
        <i class="material-icons left" style="font-size: 18px; line-height: 18px">
          info
        </i>

        <span>{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "Venue Audit",
  },

  subtitle: {
    type: String,
    default: "Complete each section, then check your score.",
  },

  meta: {
    type: String,
    default: "",
  },

  venueScore: {
    type: Number,
    required: true,
  },

  adminScore: {
    type: Number,
    required: true,
  },

  answeredCount: {
    type: Number,
    required: true,
  },

  totalCount: {
    type: Number,
    required: true,
  },

  message: {
    type: String,
    default: "",
  },
});

const progressPercent = computed(() => {
  if (!props.totalCount) return 0;

  const pct = Math.round((props.answeredCount / props.totalCount) * 100);

  return Math.max(0, Math.min(100, pct));
});
</script>

<style scoped>
.audit-header-row {
  margin-bottom: 0;
}

.score-col {
  margin-top: 6px;
}

.score-pill-row {
  margin-bottom: 0;
}

.header-subtitle {
  opacity: 0.85;
  font-size: 13px;
  margin-top: 2px;
}

.header-meta {
  opacity: 0.85;
  font-size: 12px;
  margin-top: 6px;
}

.pill {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 10px;
  text-align: center;
}

.pill .label {
  font-size: 12px;
  opacity: 0.9;
}

.pill .value {
  font-size: 18px;
  font-weight: 800;
  margin-top: 2px;
}

.progress-wrap {
  margin-top: 6px;
}

.progress-text {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 6px;
}

.message-row {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  font-size: 13px;
  opacity: 0.92;
}

.card-title {
  font-weight: 800 !important;
}

@media (max-width: 600px) {
  .audit-header {
    padding: 16px;
  }

  .card-title {
    font-size: 1.45rem;
    line-height: 1.25;
  }

  .header-subtitle {
    font-size: 12px;
  }

  .score-col {
    margin-top: 14px;
  }

  .score-pill-row {
    display: flex;
    gap: 8px;
  }

  .score-pill-row .col {
    padding: 0 !important;
    flex: 1 1 0;
  }

  .pill {
    padding: 8px 4px;
    border-radius: 10px;
  }

  .pill .label {
    font-size: 11px;
  }

  .pill .value {
    font-size: 15px;
  }

  .message-row {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    line-height: 1.35;
  }

  .message-row i {
    margin-right: 0 !important;
  }
}
</style>
